/**
 * GSAP-friendly easings that mirror the CSS tokens in `src/base/_design-tokens.scss`.
 * Motion components import from here so GSAP timelines feel identical to CSS transitions.
 */
export const easeSnappy = 'cubic-bezier(0.22, 1, 0.36, 1)';
export const easeSoft   = 'cubic-bezier(0.16, 1, 0.3, 1)';

export const durFast   = 0.22;
export const durMedium = 0.42;
export const durSlow   = 0.72;
